import './CreateInvite.css';
import { useEffect, useState, useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import axios from 'axios';
import config from '../../config';
import Invite from '../../components/invite/Invite'
import Popup from '../../components/popup/Popup';
import React from 'react'

export default function CreateInvite() {
    const [showPopup, setShowPopup] = useState(false);
    const [popupMessage, setPopupMessage] = useState('');
    const [allInvitesLoaded, setAllInvitesLoaded] = useState(false);
    // initialize state for invites
    const [invites, setInvites] = useState();
    const { user } = useContext(AuthContext);
    // used for catch blocks
    const popupStaus = async (message) => {
        setPopupMessage(message);
        setShowPopup(true);
    };

    // make call to api to get invites
    useEffect(() => {
       fetchInvites();
    }, []);

    const fetchInvites = async () => {
        try {
            const userInvites = await axios.get(`${config.apiUrl}/invites/${user._id}`)
            setInvites(userInvites.data);
            setAllInvitesLoaded(true);

        } catch (error) {
            await popupStaus("An error occured when fetching invites. Please try again later.");
        }
    };


    return (
        <div className='create-invite-container'>
        <Popup isPopupOpen={showPopup} message={popupMessage} button1Text="Close" button1Action={() => setShowPopup(false)} />
        {allInvitesLoaded && (
            <>
                <h2 className='create-invite-heading'>Available Invites</h2>
                {invites.map((i, index) => (
                    <Invite key={i._id + '-' + index} invite={i}  className='invite-container' />
                ))}
            </>
        )}
    </div>
    )
}
